import { createSlice } from "@reduxjs/toolkit";
import Api from "../../api/Api";
import {IObjectKeys} from "../../constants/interfaces";

type State = {
	data: IObjectKeys,
	isLoading: boolean,
	error: Object | null
}

// Slice
const slice = createSlice({
	name: "chartforecast",
	initialState: {
		data: {},
		isLoading: false,
		error: null,
	},
	reducers: {
		fetchChartForecastStart: (state: State) => {
			state.isLoading = true;
		},
		fetchChartForecastSuccess: (state: State, action) => {
			state.isLoading = false;
			state.data[action.payload.cellId] = action.payload.data;
		},
		fetchChartForecastFailed: (state: State, action) => {
			state.isLoading = false;
			state.error = action.payload;
		},
		resetToInitialState: (state: State) => {
			state.data = {};
			state.isLoading = false;
			state.error = null;
		}
	},
});

export default slice.reducer;

// Actions
const {
	fetchChartForecastStart,
	fetchChartForecastSuccess,
	fetchChartForecastFailed,
	resetToInitialState
} = slice.actions;

export const getChartForecast = (metric: string, brand: string | null, dayOfTheWeek: number, cellId: number) => async (dispatch: Function) => {
	try {
		dispatch(fetchChartForecastStart());
		const api = new Api();
		const result = await api.getChartForechast(brand, dayOfTheWeek);
		const payload = {
			data: result.forecast,
			metric,
			cellId
		}
		if (result !== "No internet connection") {
			dispatch(fetchChartForecastSuccess(payload));
		}
	} catch (err: any) {
		dispatch(fetchChartForecastFailed(err));
	}
};

export const resetChartForecastState = () => async (dispatch: Function) => {
	dispatch(resetToInitialState())
}
